var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / GL",
    clipPath: "url(#clip0_1718_1990)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.375 24.2083V22.0592H17.2697V24.2083H4.375ZM10.4463 18.9967L4.375 12.9254L6.63158 10.6151L12.7566 16.6864L10.4463 18.9967ZM17.2697 12.1732L11.1985 6.04821L13.5088 3.79163L19.58 9.8629L17.2697 12.1732ZM22.2127 23.1337L8.18969 9.11071L9.69408 7.60632L23.7171 21.6293L22.2127 23.1337Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1718_1990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlIcon);
export default __webpack_public_path__ + "static/media/GL-icon.a7af6adba080588beeb523190bce63c1.svg";
export { ForwardRef as ReactComponent };